// src/helpers/tenantModuleHelper.js
import cookieHelper from "./getCookieData";

export const DEFAULT_ALL_MODULES = [
  "billing_accounts",
  "dental_chart",
  "prescriptions",
  "investigations_files",
  "clinical_notes",
  "multi_chair",
  "advanced_reports",
  "whatsapp_bot",
  "daily_briefing",
  "sms_reminders",
  "patient_portal",
  "kiosk",
];

/**
 * Extract active enabled modules for current clinic workspace
 */
export const getTenantEnabledModules = () => {
  try {
    const clinicCookie = cookieHelper.getCookie("_c");
    if (clinicCookie) {
      const parsedClinic = JSON.parse(atob(clinicCookie));
      if (Array.isArray(parsedClinic?.enabled_modules)) {
        return parsedClinic.enabled_modules;
      }
      if (Array.isArray(parsedClinic?.features)) {
        return parsedClinic.features;
      }
      if (typeof parsedClinic?.features === "string") {
        try {
          return JSON.parse(parsedClinic.features);
        } catch {
          // ignore
        }
      }
    }

    const localClinic = localStorage.getItem("clinic_data");
    if (localClinic) {
      const parsed = JSON.parse(localClinic);
      if (Array.isArray(parsed?.enabled_modules)) {
        return parsed.enabled_modules;
      }
    }
  } catch (err) {
    console.warn("Failed to parse tenant modules:", err);
  }

  return DEFAULT_ALL_MODULES;
};

/**
 * Check if a specific module is enabled for the active tenant clinic
 * @param {string} moduleKey e.g. 'billing_accounts', 'dental_chart', 'whatsapp_bot'
 * @returns {boolean}
 */
export const isModuleEnabled = (moduleKey) => {
  if (!moduleKey) return true;
  const enabled = getTenantEnabledModules();
  return enabled.includes(moduleKey);
};

// Convenience shortcuts
export const isPaymentModuleEnabled = () => isModuleEnabled("billing_accounts");
export const isDentalChartEnabled = () => isModuleEnabled("dental_chart");
export const isPrescriptionsEnabled = () => isModuleEnabled("prescriptions");
export const isInvestigationsEnabled = () => isModuleEnabled("investigations_files");
export const isNotesEnabled = () => isModuleEnabled("clinical_notes");
export const isMultiChairEnabled = () => isModuleEnabled("multi_chair");
export const isReportsEnabled = () => isModuleEnabled("advanced_reports");
export const isWhatsappEnabled = () => isModuleEnabled("whatsapp_bot");
export const isDailyBriefingEnabled = () => isModuleEnabled("daily_briefing");
export const isPatientPortalEnabled = () => isModuleEnabled("patient_portal");
export const isKioskEnabled = () => isModuleEnabled("kiosk");

export default {
  getTenantEnabledModules,
  isModuleEnabled,
  isPaymentModuleEnabled,
  isDentalChartEnabled,
  isPrescriptionsEnabled,
  isInvestigationsEnabled,
  isNotesEnabled,
  isMultiChairEnabled,
  isReportsEnabled,
  isWhatsappEnabled,
  isDailyBriefingEnabled,
  isPatientPortalEnabled,
  isKioskEnabled,
};
